import { useMutation, useQueryClient } from "@tanstack/vue-query";
import User from "@/services/user";
import { invalidateBillingQueriesWithDelay } from "@/composables/billing";

export interface EditUserPayload {
  id: string;
  fullName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  role?: string;
  jobTitle?: string | null;
}

function buildEditUserFormData(payload: EditUserPayload): FormData {
  const formData = new FormData();
  formData.append("id", payload.id);
  if (payload.fullName != null) formData.append("fullName", payload.fullName);
  if (payload.email != null) formData.append("email", payload.email);
  if (payload.phoneNumber != null) formData.append("phoneNumber", payload.phoneNumber);
  if (payload.role != null) formData.append("role", payload.role);
  if (payload.jobTitle != null) formData.append("jobTitle", payload.jobTitle);
  return formData;
}

export function useEditUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditUserPayload) => {
      const formData = buildEditUserFormData(payload);
      const result = await User.editUser(formData);
      if (result?.data?.status) {
        return result.data.data;
      }
      throw new Error(result?.data?.msg || "Failed to edit user");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      invalidateBillingQueriesWithDelay(queryClient);
    },
  });
}
